import PropTypes from 'prop-types';
import React from "react";
import { Routes, Route } from 'react-router-dom';
import { connect } from "react-redux";

// Import Routes all
import { userRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout";

import LoginPage from 'ATSComponents/login';

import RegistrationPage from 'ATSComponents/Registration';

import CandidateForm from 'ATSComponents/Candidates/CandidateForm';

// import CallReport from 'ATSComponents/Reports/CallReport';
import JobsPreviewForm from 'ATSComponents/JobsAts/JobForm1';
// import Dashboard from 'pages/Dashboard';
import CalenderAll from 'ATSComponents/Calendar/CalenderAll';
import CalenderActive from 'ATSComponents/Calendar/CalenderActive';

import "./App.css"
// Import scss
import "./assets/scss/theme.scss";
import "./assets/css/main.css";
import "./assets/css/style-new.css";
import "./assets/css/responsive.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';               // Core CSS
import '@fortawesome/fontawesome-free/css/all.min.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import AutoLogin from 'ATSComponents/Autologin';
import ConsentFile from 'ATSComponents/ConsetFile';
import ConsentSchedule from 'ATSComponents/ConsentSchedule';
import ConsentUnsubscribe from 'ATSComponents/ConsentUnsubscribe.js';
import JobOwnerScreeningQuestions from 'ATSComponents/JobOrder/JobOwnerScreeningQuestions';






const App = () => {

  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/auto-login" element={<AutoLogin/>} />
        <Route path="/apply-job/get-job/:id" element={<CandidateForm />} />
        <Route path="/job-owner-screening-questions" element={<JobOwnerScreeningQuestions />} />
        <Route path="/callconsent/:token1" element={<ConsentFile />} />
        <Route path="/consent-schedule" element={<ConsentSchedule />} />
        <Route path="/consent-schedule/:token1" element={<ConsentSchedule />} />
        <Route path="/consent-unsubscribe" element={<ConsentUnsubscribe />} />
        <Route path="/jobs-form" element={<JobsPreviewForm />} />
        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                {route.component}
              </Authmiddleware>}
            key={idx}
            exact={true}
          />
        ))}
      </Routes>
    </React.Fragment>

  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
